(function () {
  function getPanel(modal) {
    return modal ? modal.querySelector('[data-collaboration-modal-panel]') : null;
  }

  function openModal(modal) {
    if (!modal) return;

    modal.hidden = false;
    modal.classList.add('is-visible');
    document.documentElement.classList.add('collaboration-modal-open');
    if (document.body) {
      document.body.classList.add('collaboration-modal-open');
    }

    window.setTimeout(function () {
      var panel = getPanel(modal);
      if (panel) {
        panel.focus();
      }
    }, 0);
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-visible');
    modal.hidden = true;
    document.documentElement.classList.remove('collaboration-modal-open');
    if (document.body) {
      document.body.classList.remove('collaboration-modal-open');
    }
  }

  function setupModal(modal) {
    if (!modal || modal.dataset.collaborationModalReady === 'true') return;

    modal.dataset.collaborationModalReady = 'true';

    modal.querySelectorAll('[data-collaboration-modal-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeModal(modal);
      });
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal(modal);
      }
    });

    if (modal.dataset.autoOpen === 'true') {
      openModal(modal);
    }
  }

  function setupPreviewForm(form) {
    if (!form || form.dataset.collaborationPreviewReady === 'true') return;

    form.dataset.collaborationPreviewReady = 'true';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      openModal(document.querySelector('[data-collaboration-success-modal]'));
    });
  }

  function init(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-collaboration-success-modal]').forEach(setupModal);
    scope.querySelectorAll('[data-collaboration-preview-form]').forEach(setupPreviewForm);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-collaboration-success-modal].is-visible').forEach(closeModal);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
